import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";

const VitrineInfoModal = ({ show, onHide, application }) => {
  const { t } = useTranslation();

  if (!application) return null;

  const imageUrl = application.pdfInfoImageName
    ? ApiHelper.cloudFrontURL + folderEnum.info + application.pdfInfoImageName
    : null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="vitrine-info-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fs-4 fw-bold text-dark">{application.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        {/* Description */}
        {application.description && (
          <div className="mb-4">
            <p className="text-muted lh-lg" style={{ fontSize: "0.95rem" }}>
              {application.description}
            </p>
          </div>
        )}

        {/* PDF Info Image */}
        {imageUrl && (
          <div className="text-center mt-4">
            <div className="position-relative d-inline-block">
              <img
                src={imageUrl}
                alt={application.name}
                className="img-fluid rounded-3 shadow"
                style={{
                  maxHeight: "600px",
                  objectFit: "contain",
                  border: "1px solid #e9ecef",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
          </div>
        )}

        {/* If no image and no description */}
        {!application.description && !imageUrl && (
          <div className="text-center text-muted py-5">
            <i className="bi bi-inbox fs-1 mb-3 d-block opacity-50"></i>
            <p className="mb-0">{t("noInformationAvailable")}</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-2 pb-3">
        <Button variant="outline-secondary" onClick={onHide} className="px-4 rounded-pill">
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VitrineInfoModal;
